import React from 'react';
import { CFooter } from '@coreui/react';
import { Language } from '../../language/English';

export const AppFooter = () => {
    const currentYear = new Date().getFullYear();
    return (
        <CFooter>
            {/* <div>
        <a href="/" target="_blank" rel="noopener noreferrer">
          { 
            Language.PANEL_NAME
          }
        </a>
        <span className="ms-1">&copy; {currentYear}</span>
      </div> */}
            <div className="ms-auto">
                <span className="me-1">Powered by</span>
                <a href="/" target="_blank" rel="noopener noreferrer">
                    {Language.PANEL_NAME}
                </a>
                <span className="ms-1">&copy; {currentYear}</span>
            </div>
        </CFooter>
    );
};
